import React from "react";
import ChangeCheckContext from "../support/ChangeCheckContext";

function useChangeCheck(onChangeProp) {
    // This custom hook adds behaviour which handles form component changes.
    const { changeCheckReset } = React.useContext(ChangeCheckContext);
    const [changed, setChanged] = React.useState(false);
    function onChange(event) {
        setChanged(true);
        onChangeProp(event)
    }

    function getStyle() {
        return changed ? { backgroundColor: '#fffdcc' } : null;
    }

    React.useEffect(() => {
        setChanged(false);
    }, [changeCheckReset]);

    return {onChange, getStyle};
}

export default useChangeCheck;